import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'plural'
})
export class PluralPipe implements PipeTransform {

  transform(value: string, args: number): unknown {
    return args === 1 ? value : value + 's';
  }

}

@Pipe({
  name: 'pluralSuffix'
})
export class PluralSuffixPipe implements PipeTransform {

  transform(count: number, suffix = 's'): unknown {
    return count === 1 ? suffix : suffix;
  }

}
